<template>
  <div>
    <Modal :option="'diff'" @close="$emit('close')">
      <Loading v-show="loading" />
      <div v-if="!loading">
        <div class="p-modal__content__header">
          {{ $t('pages.CompaniesLocationStoresBulkEdit.diffModal.header') }}<span class="store-amounts">{{ targetStoreAmount + $t('models.store.modelName') }}</span>）
        </div>
        <div class="p-modal__content__body">
          <div class="p-table">
            <div class="p-table__content">
              <div class="p-box__body">
                <div v-if="differences.length === 0">
                  {{ $t('pages.CompaniesLocationStoresBulkEdit.diffModal.noDiff') }}
                </div>
                <table v-else>
                  <thead>
                    <tr>
                      <th>
                        {{ $t('models.store.name') }}
                      </th>
                      <th>
                        {{ $t('pages.CompaniesLocationStoresBulkEdit.diffModal.changeLocation') }}
                      </th>
                      <th>
                        {{ $t('pages.CompaniesLocationStoresBulkEdit.diffModal.changeBefore') }}
                      </th>
                      <th>
                        {{ $t('pages.CompaniesLocationStoresBulkEdit.diffModal.changeAfter') }}
                      </th>
                    </tr>
                    <tr class="p-table__content__space">
                      <td colspan="4" />
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item,i) in differences" :key="i">
                      <tr>
                        <td v-if="item.name" :rowspan="item.diffCount" class="table-head">
                          {{ item.name }}
                        </td>
                        <td v-if="item.type.name" :rowspan="item.type.diffCount" class="table-head">
                          {{ item.type.name }}
                        </td>
                        <td v-if="item.type.key === 'regularHour'">
                          <p v-for="(text,k) in item.beforeValue" :key="k">
                            {{ text }}
                          </p>
                        </td>
                        <td v-else-if="item.type.key === 'specialHour'">
                          <p v-for="(text,k) in item.beforeValue" :key="k">
                            {{ text }}
                          </p>
                        </td>
                        <td v-else-if="item.type.key === 'paymentMethod'">
                          {{ item.beforeValue + ' ' }}
                          <template v-if="item.values.before === 'ok'">
                            <Icon name="iconOk" />
                          </template>
                          <template v-else-if="item.values.before === 'ng'">
                            <Icon name="iconCrossRed" />
                          </template>
                          <template v-else>
                            {{ $t('pages.CompaniesLocationStoresBulkEdit.diffModal.noSet') }}
                          </template>
                        </td>
                        <td v-else-if="item.type.key === 'gmbLocation'">
                          {{ item.beforeValue + ' ' }}
                          <Icon v-if="item.values.before" name="iconOk" />
                          <Icon v-else name="iconCrossRed" />
                        </td>
                        <td v-else>
                          {{ item.beforeValue || $t('pages.CompaniesLocationStoresBulkEdit.diffModal.noSet') }}
                        </td>
                        <td v-if="item.type.key === 'regularHour'">
                          <p v-for="(text,k) in item.afterValue" :key="k">
                            {{ text }}
                          </p>
                        </td>
                        <td v-else-if="item.type.key === 'specialHour'">
                          <p v-for="(text,k) in item.afterValue" :key="k">
                            {{ text }}
                          </p>
                        </td>
                        <td v-else-if="item.type.key === 'paymentMethod'">
                          {{ item.afterValue + ' ' }}
                          <template v-if="item.values.after === 'ok'">
                            <Icon name="iconOk" />
                          </template>
                          <template v-else-if="item.values.after === 'ng'">
                            <Icon name="iconCrossRed" />
                          </template>
                          <template v-else>
                            {{ $t('pages.CompaniesLocationStoresBulkEdit.diffModal.noSet') }}
                          </template>
                        </td>
                        <td v-else-if="item.type.key === 'gmbLocation'">
                          {{ item.afterValue + ' ' }}
                          <Icon v-if="item.values.after" name="iconOk" />
                          <Icon v-else name="iconCrossRed" />
                        </td>
                        <td v-else>
                          {{ item.afterValue || $t('pages.CompaniesLocationStoresBulkEdit.diffModal.noSet') }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="p-modal__content__footer">
          <div class="c-button c-button--right">
            <div class="js-close" />
            <button
              class="c-button__item c-button__item--outline-cancel"
              @click="$emit('close')"
              v-text="$t('labels.cancel')"
            />
            <button
              v-if="differences.length !== 0"
              type="button"
              class="c-button__item c-button__item--primary"
              @click="$emit('submit')"
              v-text="$t('labels.confirm')"
            />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Loading from '../Loading'
import Modal from '../Modal'
import Icon from '../Icon.vue'

export default {
  name: 'DiffModal',
  components: {Modal, Loading, Icon},
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    differences: {
      type: Array,
      required: true,
    },
    targetStoreAmount: {
      type: Number,
      required: true,
    }
  },
  emits: ['close', 'submit'],
}
</script>

<style lang="scss" scoped>
.p-modal--diff {
  :deep(.p-modal__content) {
    width: auto;
  }
  :deep(.p-modal__body) {
    width: 80%
  }
  .p-modal__content__body {
    overflow-y: visible;
  }
  .p-table__content {
    height: 100%;
  }
  .p-box__body {
    height: 100%;
    padding: 0;
  }
  .p-table {
    height: 100%;
    margin-top: 0;
  }
  th {
    position: sticky;
    top: 0;
  }
}
tbody .table-head {
  background-color: #F8F9FA;
}
</style>
